import React from 'react';
import { number, string, object } from 'prop-types';
import cx from 'classnames';
import useStyles from 'hooks/useStyles';

import styles from './LineProgressBar.scss';

function LineProgressBar({ progress, classNameMap, textStart, textEnd }) {
  useStyles(styles);
  const isCompleted = progress === 1;
  const percentageOfProgress = Math.trunc(progress * 100);

  return (
    <div className={cx(styles.root, classNameMap.root)}>
      <div className={styles.status}>
        {textStart && (
          <p className={cx(styles.start, classNameMap.start)}> {textStart}</p>
        )}
        {textEnd && (
          <p className={cx(styles.end, classNameMap.end)}> {textEnd} </p>
        )}
      </div>
      <div className={cx(styles.progressBody, classNameMap.progressBody)}>
        <div
          className={cx(styles.bar, {
            [styles.completed]: isCompleted,
          })}
          style={{ width: `${percentageOfProgress}%` }}
        />
      </div>
    </div>
  );
}

LineProgressBar.propTypes = {
  progress: number.isRequired,
  classNameMap: object,
  textStart: string,
  textEnd: string,
};

LineProgressBar.defaultProps = {
  classNameMap: {},
  textStart: '',
  textEnd: '',
};

export default LineProgressBar;
